import { settleApiCall } from '../api/utils';
import { convertDisplayedModifiersToModifiersDTO } from '../utils/converters';
import { categorizeByExistence, filterOutDuplicatedNames } from './utils/common';
import { cleanDoubleAndTrailingSpace } from '../utils/modifiers';
import { createFieldToEntityMap } from '../utils/common';
export const createModifiers = async (modifiers, modifiersClient) => {
  const modifiersInDTOForm = convertDisplayedModifiersToModifiersDTO(modifiers);
  const getExistingModifiersResponse = await settleApiCall(() => modifiersClient.query({
    filter: {
      name: {
        $in: modifiersInDTOForm.map(modifier => modifier.name)
      }
    }
  }));
  if (getExistingModifiersResponse.hasError) {
    return getExistingModifiersResponse;
  }
  const existingModifiersMap = createFieldToEntityMap(getExistingModifiersResponse.data.data, 'name');
  const {
    newEntities: newModifiers,
    existingEntities: existingModifiers
  } = categorizeByExistence(modifiersInDTOForm, existingModifiersMap);
  const newModifiersWithoutDuplicates = filterOutDuplicatedNames(newModifiers);
  const newModifiersForCreation = newModifiersWithoutDuplicates.map(modifier => ({
    name: modifier.name,
    inStock: modifier.inStock ?? true
  }));
  const createModifiersResponse = newModifiersForCreation.length > 0 ? await settleApiCall(() => modifiersClient.bulkCreate(newModifiersForCreation)) : undefined;
  if (createModifiersResponse != null && createModifiersResponse.hasError) {
    return createModifiersResponse;
  }
  const allModifiers = [...((createModifiersResponse == null ? void 0 : createModifiersResponse.data) || []), ...(existingModifiers || [])];
  const namesToModifiersMap = createFieldToEntityMap(allModifiers, 'name');
  const modifiersWithIds = modifiers.map(modifier => {
    const modifierName = cleanDoubleAndTrailingSpace(modifier.name);
    const createdModifier = namesToModifiersMap[modifierName];
    return {
      name: createdModifier.name,
      additionalChargeInfo: modifier.additionalChargeInfo,
      preSelected: modifier.preSelected,
      id: createdModifier.id,
      inStock: createdModifier.inStock ?? true,
      revision: createdModifier.revision,
      businessLocationIds: createdModifier.businessLocationIds ?? []
    };
  });
  return {
    data: modifiersWithIds,
    hasError: false
  };
};
//# sourceMappingURL=createModifiers.js.map